import { render, staticRenderFns } from "./ModalProfile.vue?vue&type=template&id=645e61c6"
import script from "./ModalProfile.vue?vue&type=script&lang=js"
export * from "./ModalProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports